<div class="therapy-offer box-shadow mr-b--md">
    <div class="table--grid">
        <div class="row" *ngIf="therapyStep > 1">
            <div class="col-xs-12">
                <a class="btn btn-link btn-icon btn-icon--left btn-back" (click)="goNextPage(true)">
                    {{ 'Back to' | translate }} {{ STEPTITLE[previousStep] | translate }}
                </a>
            </div>
        </div>
        <div class="table--grid__header">
            <div class="table--grid__header--title pull-left">
                {{ STEPTITLE[therapyStep] | translate }}
            </div>
        </div>
        <div class="table--grid__body no-hover">
            <div class="table--grid__body table--grid__body--content">
                <ng-container *ngIf="countries.length && insurances.length && therapyStep === 1">
                    <div class="row">
                        <div class="col-xs-10">
                            <span class="table--grid__header--description pull-left mt-1">
                                {{ 'Choose the patients country firsts.' | translate }}
                            </span>
                        </div>
                    </div>
                    <div class="row no-hover">
                        <div class="col-xs-8">
                            <div class="row form-group">
                                <div class="col-xs-4">
                                    <span>
                                       {{ 'Country' | translate }}
                                    </span>
                                </div>
                                <div class="col-xs-8">
                                    <mat-select disabled [placeholder]="'Select Country' | translate"
                                                [(value)]="selectedCountry">
                                        <mat-option *ngFor="let country of countries; let i = index"
                                                    [value]="country.id">
                                            {{country.name | translate}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="row form-group" *ngIf="insurancesCollection">
                                <div class="col-xs-4">
                                <span>
                                   {{ 'Insurance type' | translate }}
                                </span>
                                </div>
                                <div class="col-xs-8">
                                    <ng-select2
                                            class="selected-sp__filter"
                                            [width]="'100%'"
                                            [value]="id"
                                            [(ngModel)]="selectedInsurances"
                                            [options]="select2Options"
                                            *ngIf="insurances.length"
                                            (valueChanged)="onChangeInsurances($event)"
                                            [data]="insurancesCollection">
                                    </ng-select2>
                                </div>
                            </div>
                            <div class="row form-group" *ngIf="insurancesCollection">
                                <div class="col-xs-4">
                                    <span>
                                       {{ 'Group therapy allowed' | translate }}
                                    </span>
                                </div>
                                <div class="col-xs-8">
                                    <input type="checkbox" [(ngModel)]="groupTherapy" value="1" id="group-therapy">
                                    <label for="group-therapy"></label>
                                </div>
                            </div>
                            <div class="row hidden"></div>
                        </div>
                        <div class="col-xs-1 offset-xs-3 next-step">
                            <i class="fal fa-arrow-circle-right next-step--icon" (click)="goNextPage()"></i>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="serviceProviders && serviceProviders.length && therapyStep === 2">
                    <div class="row">
                        <div class="col-xs-10">
                            <span class="table--grid__header--description pull-left mt-1">
                                {{ 'Based on the selected diagnoses, the service provider categories and service providers matching these diagnoses are displayed.' | translate }}
                            </span>
                        </div>
                    </div>
                    <div class="row service-providers">
                        <div class="col-xs-11">
                            <div class="row">
                                <div class="col-xs-1"></div>
                                <div *ngFor="let column of serviceProvidersTableColumns" class="{{ column[2] }} service-providers-header">
                                    {{ column[1] | translate }}
                                    <ng-container *ngIf="column[0] === 'languages' && languageFilters.length">
                                        <mat-form-field class="mat-menu-filter">
                                            <i class="fal fa-filter" [class.active]="filterBy?.languages?.length"></i>
                                            <mat-select [(ngModel)]="filterBy.languages" [multiple]="true" #multiSelect>
                                                <mat-option *ngFor="let filter of languageFilters" [value]="filter['code']">
                                                    {{ filter['code'] }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="column[0] === 'zip_code' && zipcodeFilters.length">
                                        <mat-form-field class="mat-menu-filter">
                                            <i class="fal fa-filter" [class.active]="filterBy?.zip_code?.length"></i>
                                            <mat-select [(ngModel)]="filterBy.zip_code" [multiple]="true" #multiSelect>
                                                <mat-option *ngFor="let filter of zipcodeFilters" [value]="filter">
                                                    {{ filter }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row service-providers-list">
                        <div class="col-xs-11">
                            <ng-container *ngFor="let category of serviceProviders; let last = last;">
                                <div class="row hidden"></div>
                                <div class="row d-flex align-items-center service-providers-list--category mt-1">
                                    <div class="col-xs-1">
                                        <input type="checkbox" [(ngModel)]="category['selected']" [id]="'category_' + category['id']" (change)="toggleSPCategory(category['service_providers'], category['selected'])">
                                        <label [for]="'category_'+ category['id']"></label>
                                    </div>
                                    <div class="col-xs-11 service-providers-list--category--name" [class.selected]="category['selected']">
                                        <h3>{{ category['name_' + translate.currentLang] | translate}}</h3>
                                    </div>
                                </div>
                                <ng-container *ngIf="category['service_providers'].length > 0">
                                    <div class="row" *ngFor="let sp of category['service_providers']; let lastSP = last;"
                                         [class.hidden]="!isFilteredBy(sp)">
                                        <div class="col-xs-11 offset-xs-1">
                                            <div class="row d-flex align-items-center service-providers-list--item"
                                                 [class.selected]="sp['selected']"
                                                 [class.expanding]="sp['expanding']">
                                                <div class="col-xs-1 sp-checkbox">
                                                    <input type="checkbox" [(ngModel)]="sp['selected']" (change)="selectSP(sp, $event)" [id]="'spitem_' + sp['id']">
                                                    <label [for]="'spitem_' + sp['id']"></label>
                                                </div>

                                                <div *ngFor="let column of serviceProvidersTableColumns" class="{{ column[2] }}" (click)="sp['expanding'] = !sp['expanding']">
                                                    <ng-container *ngIf="column[0] === 'name'">
                                                        <span class="">
                                                            {{ sp['name_' + translate.currentLang] | translate}}
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="column[0] === 'insurance'">
                                                        <span>
                                                            {{ sp['insurance'] ? (sp['insurance']['name_' + translate.currentLang] | translate) : '-' }}
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="column[0] === 'languages'">
                                                        <span>
                                                            {{ ld.map(sp[column[0]], 'code').toString(',') || '-'}}
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="column[4] === 'not-custom'">
                                                        <span>
                                                            {{ sp[column[0]] || '-'}}
                                                        </span>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row d-flex service-providers-list--item description" [class.selected]="sp['selected']" [class.expanding]="sp['expanding']">
                                                <div class="col-xs-6">
                                                    <div class="row" *ngFor="let col of SPDescriptionColumns" class="{{ col[3] }}">
                                                        <div class="col-xs-5">
                                                            {{ col[1] | translate}}:
                                                        </div>
                                                        <div class="col-xs-7">
                                                            <span *ngIf="col[2] === 'translation' && (sp[col[0]] || sp[col[0] + translate.currentLang]); else orginal">
                                                                {{ sp[col[0] + translate.currentLang] || sp[col[0]]['name_' + translate.currentLang] || 'n/a'}}
                                                            </span>

                                                            <ng-template #orginal>
                                                                <span *ngIf="sp[col[0]] && col[4]; else noData">
                                                                    {{ sp[col[0]][col[4]] }}
                                                                </span>
                                                                <ng-template #noData>
                                                                    <span> n/a </span>
                                                                </ng-template>
                                                            </ng-template>
                                                        </div>
                                                    </div>
                                                    <div class="row desc-details">
                                                        <div class="col-xs-5">
                                                            {{ 'Website' | translate}}: <br />
                                                        </div>
                                                        <div class="col-xs-12">
                                                            {{ sp['website'] || 'n/a'}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-6 desc-details">
                                                    {{ 'Description' | translate}} : <br />
                                                    {{ sp['description_' + translate.currentLang]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </ng-container>
                        </div>
                        <div class="col-xs-1 next-step">
                            <i class="fal fa-arrow-circle-right next-step--icon" [class.disabled]="countSelected === 0" (click)="goNextPage()"></i>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="serviceProviders && serviceProviders.length && therapyStep === 3">
                    <div class="row">
                        <div class="col-xs-10">
                            <span class="table--grid__header--description pull-left mt-1">
                                {{ 'If one of the selected service proviers is in the service provider category DiGA, you have to check the contraindications as well.' | translate }}
                            </span>
                        </div>
                    </div>
                    <div class="row service-providers">
                        <div class="col-xs-11">
                            <div class="row">
                                <div class="col-xs-1"></div>
                                <div *ngFor="let column of ContraindicationsColumns" class="{{ column[2] }} service-providers-header">
                                    {{ column[1] | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row service-providers-contrain">
                        <div class="col-xs-11">
                            <ng-container *ngFor="let category of serviceProviders; let last = last;">
                                <div class="row hidden"></div>
                                <ng-container *ngIf="category['service_providers'].length > 0">
                                    <div class="row" *ngFor="let sp of category['service_providers']; let lastSP = last;"
                                         [class.hidden]="!sp['selected']">
                                        <div class="col-xs-11 offset-xs-1">
                                            <div class="row mb-1 service-providers-contrain--spitem" *ngIf="sp['contraindications'].length">
                                                <div class="col-xs-4 col-sp">
                                                    {{ sp['name_' + translate.currentLang] }}
                                                </div>
                                                <div class="col-xs-7 col-contrain">
                                                    <div class="row" *ngFor="let contrain of sp['contraindications']">
                                                        <div class="col-xs-2">
                                                            {{ contrain['code'] }}
                                                        </div>
                                                        <div class="col-xs-10">
                                                            {{ contrain['name_' + translate.currentLang] }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-1 col-check">
                                                    <input type="radio" [id]="sp['id']" value="1" (change)="contrainReviewed.push(sp);" [checked]="ld.includes(contrainReviewed, sp)"/>
                                                    <label [for]="sp['id']"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </ng-container>
                        </div>
                        <div class="col-xs-1 next-step">
                            <i class="fal fa-arrow-circle-right next-step--icon" [class.disabled]="contrainReviewed.length !== contrainSelected.length" (click)="goNextPage()"></i>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="serviceProviders && serviceProviders.length && therapyStep >= STEPS.PREVIEW_REPORT">
                    <div class="row">
                        <div class="col-xs-11">
                            <span class="table--grid__header--description pull-left mt-1">
                                {{ 'You can now review the automatically generated evaluation report.' | translate }}
                            </span>
                        </div>
                        <div class="col-xs-1 next-step">
                            <i class="fal fa-arrow-circle-right next-step--icon" (click)="goNextPage()"></i>
                        </div>
                    </div>
                    <div class="row service-providers">
                        <div class="col-xs-12 service-providers-report">
                            <i class="fal fa-edit service-providers-report--edit-icon hidden"></i>
                            <div class="report-data box-shadow" *ngIf="pdfContent && pdfContent.length"
                                 (click)="handleEvent($event)"
                            >
                                <div [innerHtml]="pdfStyleCss | safeHtml"></div>
                                <div *ngIf="pdfFullcontent" [innerHtml]="pdfFullcontent | safeHtml">

                                </div>
                            </div>

                        </div>

                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="!countries && !insurances">
                <div class="text-xs-center pd-v--sm">
                    {{ 'No Therapy offers.' | translate }}
                </div>
            </ng-container>
            <ng-container *ngIf="therapyStep === 2 && serviceProviders.length < 1">
                <div class="text-xs-center pd-v--sm">
                    {{ 'No matching service providers' | translate }}
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div bsModal #modalEdit="bs-modal" class="modal fade diagnosis-notify-modal modal-confirmation" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-confirmation-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{ 'Edit' | translate }}
                </h4>
                <button (click)="closeEdit(editingItem)" class="fal fa-times close" aria-label="Close" type="button"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12">
                        <app-tinymce *ngIf="editingItem" #tinymce [(ngModel)]='editContent' [ngModelOptions]="{standalone: true}"></app-tinymce>
                    </div>
                </div>
                <div>&nbsp;</div>
                <div class="row">
                    <div class="col-sm-12">
                        <button class="btn btn-primary" (click)="saveItem(editingItem)" type="button">{{ 'Save' | translate}}</button>&nbsp;&nbsp;
                        <button class="btn btn-dismiss" (click)="closeEdit(editingItem)" type="button">{{ 'Dismiss' | translate}}</button>
                    </div>
                </div>
                <div>&nbsp;</div>
            </div>
        </div>
    </div>
</div>